/* Daily Cart v4.12.0 (Oct 25). The sale price itself is drawn by a small inline script in theme.liquid (no flicker).
   v5.0.7 (Oct 31): the "N days left to order for Christmas" line under the price was removed from every product page (Keith). */
function dcEv(n) { try { if (typeof window.clarity === 'function') window.clarity('event', n); } catch (e) {} }

/* (2) Photo editor help: a tip line in the upload window, and a nudge with "Add my photo"
   when the window closes without a saved photo (v4.14.4: reassuring wording). */
(function () {
  try {
    var root = document.querySelector('[data-dc-product]');
    var btn = root && root.querySelector('.personalize-button');
    if (!btn) return;
    var cal = /calendar/.test(location.pathname);
    var tip = cal
      ? 'Tap <b>+ Image</b> for each month → pick your photos → tap <b>Continue</b>'
      : 'Tap <b>+ Image</b> → pick your photo → tap <b>Continue</b>';
    var saved = false, isOpen = false, modal = null, nudge = null, timer = null;

    window.addEventListener('message', function (e) {
      if (String(e.origin).indexOf('personalize.at') < 0) return;
      var m = e.data;
      try { if (typeof m === 'string') m = JSON.parse(m); } catch (x) { return; }
      if (m && m.type === 'PERSONALIZATION_APPLIED') { saved = true; hideNudge(); }
    });

    function hideNudge() { if (nudge) nudge.hidden = true; }
    function showNudge() {
      if (!nudge) {
        nudge = document.createElement('div');
        nudge.className = 'dc-pzm-nudge';
        nudge.setAttribute('role', 'status');
        nudge.innerHTML = '<p><strong>No photo added yet.</strong> ' + (cal ? 'Any photos from your phone work.' : 'Any photo from your phone works.') + ' You&rsquo;ll see your design before anything goes in your cart.</p><button type="button" class="dc-pzm-retry">Add my photo</button>';
        var app = btn.closest('.dc-pdp__app') || btn.parentNode;
        app.parentNode.insertBefore(nudge, app.nextSibling);
        nudge.querySelector('button').addEventListener('click', function () { dcEv('editor_retry'); btn.click(); });
      }
      nudge.hidden = false;
    }
    function addTip(m) {
      var hd = m.querySelector('.personalize-modal__header');
      if (!hd || hd.querySelector('.dc-pzm-tip')) return;
      var t = document.createElement('p');
      t.className = 'dc-pzm-tip';
      t.innerHTML = tip;
      hd.appendChild(t);
      hd.classList.add('dc-pzm-hd');
    }
    function check() {
      var m = document.querySelector('.personalize-modal');
      if (!m) return;
      if (m !== modal) { modal = m; watch.observe(m, { attributes: true, attributeFilter: ['style', 'class'] }); }
      var open = getComputedStyle(m).display !== 'none';
      if (open) {
        addTip(m);
        if (!isOpen) { isOpen = true; clearTimeout(timer); hideNudge(); }
      } else if (isOpen) {
        isOpen = false;
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (!isOpen && !saved && !root.classList.contains('dc-has-photo')) { showNudge(); dcEv('editor_closed_nophoto'); }
        }, 800);
      }
    }
    var watch = new MutationObserver(check);
    new MutationObserver(check).observe(document.body, { childList: true });
    check();
  } catch (err) {}
})();
